const AppRouter = ({ children }) => {
  return <>{children}</>;
};

export default AppRouter;
